import * as S from './Provider.styles'

export type ProviderProps = {
  iconUrl: string
  imageWidth?: number
  imageHeight?: number
  width?: number
  height?: number
  padding?: number
}

export default function Provider({ iconUrl, imageWidth, imageHeight, width, height, padding }: ProviderProps) {
  return (
    <S.Container $width={width} $height={height} $padding={padding}>
      <S.Image
        src={iconUrl}
        $width={imageWidth}
        $height={imageHeight}
      />
    </S.Container>
  )
}
